var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTaskLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.231322 7.51953L6.60847 13.765C7.35147 14.4788 8.50549 13.4065 7.74985 12.6772L1.9671 7.00036L7.75301 1.31733C8.50865 0.600384 7.35779 -0.478125 6.61479 0.23264L0.231322 6.48119C-0.0627157 6.76859 -0.091171 7.2105 0.231322 7.51953Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTaskLeft);
export default __webpack_public_path__ + "static/media/MyTaskLeft.665b00013906f6260191988bc2e7c51b.svg";
export { ForwardRef as ReactComponent };